export default __webpack_public_path__ + "static/media/filters_icon.cda70d63.svg";